export const BASE_MORTGAGE_CALCULATOR_URL = "/lakashitel-kalkulator/";
export const MORTGAGE_HOW_MUCH_CALCULATOR_URL = "/lakashitel-kalkulator/mennyi-lakashitelt-kaphatok/";

export const MIN_LOAN_AMOUNT = 0;
export const MAX_LOAN_AMOUNT = 50_000_000;

export const MIN_AGE = 18;
export const MAX_AGE = 99;

export const MIN_MONTHLY_INCOME = 177_422;
export const MAX_MONTHLY_INCOME = 10_000_000;

export const MIN_REAL_ESTATE_VALUE = 0;
export const MAX_REAL_ESTATE_VALUE = 100_000_000;
export const MAX_REAL_ESTATE_VALUE_IN_CASE_OF_HOUSE = 150_000_000;

export const LOAN_MATURITY_FOR_CALCULATION_IN_MONTHS = 300;

export const LOWER_INTEREST_ANNUAL = 0.03;
export const HIGHER_INTEREST_ANNUAL = 0.065;

export const BORDER_FOR_JTM_RULE = 500_000;
export const LOWER_JTM_RULE = 0.5;
export const HIGHER_JTM_RULE = 0.6;
export const REQUEST_CONSULTANT_CALL_OPTIONS = [
	{
		label: "Kérem a Bankmonitor szakértőjének ingyenes segítségét a legjobb megoldás megtalálásában",
		value: true,
	},
	{
		label: "Nem kérem az ingyenes tanácsadást",
		value: false,
	},
];
